/**
 * @created on 2017/10/24
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 课程板块
const payIndex = resolve => require(['../../../views/pay/payIndex'], resolve)

export default [
  {
    path: '/payIndex',
    component: payIndex,
    meta: {
      title: '确认订单'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/page/pay/index.js